const bytesIn1MB = 1048576;

const formatBytes = (bytes: number, decimals = 2) => {
  if (!+bytes) return '0 Bytes';
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
};

const validateFileformatAndSize = (file: File, isMessage: string, maxFileSizeInMB = 50) => {
  const validTypes = ['image/jpeg', 'image/png', 'application/pdf', 'video/mp4', 'video/x-msvideo', 'video/x-ms-wmv', 'video/quicktime', 'video/avi'];
  if (validTypes.indexOf(file.type) === -1 || (!isMessage?.length && file.type === 'application/pdf')) {
    return 'Sorry, this file type cannot be uploaded.';
  }
  // check the size
  const maxSizeInBytes = maxFileSizeInMB * bytesIn1MB; // size * 1mb
  if (file.size > maxSizeInBytes) {
    return 'Sorry, this file is too large to be attached to a message';
  }
  return '';
}

const convertFileToBase64 = (file: File) => new Promise((resolve, reject) => {
  const reader = new FileReader();
  reader.onload = () => resolve(reader.result);
  reader.onerror = reject;
  reader.readAsDataURL(file);
});

const getProgressBarSpeedlimit = (file: File) => {
  const speed = {
    interval: 0,
    limit: 0
  }
  switch (true) {
    case file.size < 1 * bytesIn1MB:
      speed.interval = 100;
      speed.limit = 13;
      break;
    case file.size < 8 * bytesIn1MB:
      speed.interval = 200;
      speed.limit = 11;
      break;
    case file.size < 18 * bytesIn1MB:
      speed.interval = 300;
      speed.limit = 9;
      break;
    case file.size < 35 * bytesIn1MB:
      speed.interval = 450;
      speed.limit = 6;
      break;
    default:
      speed.interval = 600;
      speed.limit = 4;
      break;
  }
  return speed;
};

export {
  formatBytes,
  validateFileformatAndSize,
  convertFileToBase64,
  getProgressBarSpeedlimit
};
